import getConfig from "next/config";
import { useCallback, useEffect, useState } from "react";

const {
  publicRuntimeConfig: {
    footprints: {
      desktopWebAdvertisementScriptUrl,
      mobileWebAdvertisementScriptUrl,
    },
  },
} = getConfig();

const MOBILE_FOOTPRINTS_SCRIPT_ID = "FootprintsWebAdsMobileScript";
const DESKTOP_FOOTPRINTS_SCRIPT_ID = "FootprintsWebAdsDesktopScript";

const FootprintsWebAdsBanner = ({
  desktopSize = "728x90",
  mobileSize = "320x50",
}) => {
  const [mobileScriptLoaded, setMobileScriptLoaded] = useState(false);
  const [desktopScriptLoaded, setDesktopScriptLoaded] = useState(false);

  const loadScript = useCallback(() => {
    // Add the mobile script
    const mobileScript = document.createElement("script");
    mobileScript.src = mobileWebAdvertisementScriptUrl;
    mobileScript.id = MOBILE_FOOTPRINTS_SCRIPT_ID;
    mobileScript.async = true;
    mobileScript.onload = setMobileScriptLoaded(true);

    // Add the desktop script
    const desktopScript = document.createElement("script");
    desktopScript.src = desktopWebAdvertisementScriptUrl;
    desktopScript.id = DESKTOP_FOOTPRINTS_SCRIPT_ID;
    desktopScript.async = true;
    desktopScript.onload = setDesktopScriptLoaded(true);

    // Append scripts to the document body
    document.body.appendChild(mobileScript);
    document.body.appendChild(desktopScript);
  }, []);

  useEffect(() => {
    loadScript();

    return () => {
      // Cleanup scripts on component unmount
      const mobileScript = document.getElementById(MOBILE_FOOTPRINTS_SCRIPT_ID);
      const desktopScript = document.getElementById(
        DESKTOP_FOOTPRINTS_SCRIPT_ID
      );

      if (mobileScript) {
        document.body.removeChild(mobileScript);
      }
      if (desktopScript) {
        document.body.removeChild(desktopScript);
      }
    };
  }, []);

  const scriptsLoaded = mobileScriptLoaded || desktopScriptLoaded;

  return (
    <div
      className={`${
        scriptsLoaded
          ? "flex justify-center items-center py-[20px]"
          : "invisible"
      }`}
    >
      <div className={`ffrWebAdvertising${desktopSize}Desktop`} />
      <div className={`ffrWebAdvertising${mobileSize}Mobile`} />
    </div>
  );
};

export default FootprintsWebAdsBanner;
